import React from 'react';
import { Link } from 'react-router-dom';
import { appFeatures } from '../../data/homeContent';
import mobileAppImg from '../../assests/img/mobile-app.png';

function HomeMobileApp() {
  return (
    <section className="home-section home-app">
      <div className="container home-app-inner">
        <div>
          <p className="home-kicker">SCHOOL MOBILE APP</p>
          <h2>Everything essential, from anywhere, with a tap</h2>
          <p className="home-lead">
            Manage academics, attendance, communication, approvals, transport, fees, and student welfare from one school app.
          </p>
          <div className="home-app-grid">
            {appFeatures.map((item) => (
              <article key={item.title} className="home-app-item">
                <h3>{item.title}</h3>
                <p>{item.text}</p>
              </article>
            ))}
          </div>
          <Link to="/platforms/mobile-application" className="home-btn home-btn-primary">
            Explore the app
          </Link>
        </div>
        <div className="home-app-phones">
          <img
            src={mobileAppImg}
            alt="Brightstudy school app on parent, teacher, and student phones"
          />
        </div>
      </div>
    </section>
  );
}

export default HomeMobileApp;
